import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle } from 'lucide-react';
export function ForYouSection() {
  const forYou = ['Eres mamá latina en USA, 35-50 años', 'Tienes celular Android o iPhone', 'Presión de facturas y remesas', 'Puedes dedicar 1 hora por noche', 'Primer freelance, sin experiencia previa', 'Quieres servir a negocios latinos locales'];
  const notForYou = ['Eres experta en Premiere buscando Hollywood', 'Odias TikTok y Reels', 'Tienes tiempo full-time en oficina', 'Solo buscas hobbies sin urgencia de cash'];
  return <section className="py-20 bg-[#FFF8F0]" data-id="element-106">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-107">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-108">
          {/* Left Column - For You */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-3xl shadow-lg border-t-4 border-[#1A6B5C]" data-id="element-109">
            <h3 className="text-2xl font-bold text-[#2D1B0E] mb-8 flex items-center gap-3" data-id="element-110">
              <CheckCircle className="w-8 h-8 text-[#1A6B5C]" data-id="element-111" />✅ Esto ES Para
              Ti Si...
            </h3>
            <ul className="space-y-4" data-id="element-112">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-113">
                  <div className="mt-1 w-5 h-5 rounded-full bg-[#1A6B5C]/10 flex items-center justify-center flex-shrink-0" data-id="element-114">
                    <CheckCircle className="w-3 h-3 text-[#1A6B5C]" data-id="element-115" />
                  </div>
                  <span className="text-[#2D1B0E]/80 font-medium" data-id="element-116">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Right Column - Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-white p-8 rounded-3xl shadow-lg border-t-4 border-[#E8614D]" data-id="element-117">
            <h3 className="text-2xl font-bold text-[#2D1B0E] mb-8 flex items-center gap-3" data-id="element-118">
              <XCircle className="w-8 h-8 text-[#E8614D]" data-id="element-119" />❌ NO Es Para Ti
              Si...
            </h3>
            <ul className="space-y-4" data-id="element-120">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-121">
                  <div className="mt-1 w-5 h-5 rounded-full bg-[#E8614D]/10 flex items-center justify-center flex-shrink-0" data-id="element-122">
                    <XCircle className="w-3 h-3 text-[#E8614D]" data-id="element-123" />
                  </div>
                  <span className="text-[#2D1B0E]/80 font-medium" data-id="element-124">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}